import { render, staticRenderFns } from "./secondaryCard.vue?vue&type=template&id=5d90c044&"
import script from "./secondaryCard.vue?vue&type=script&lang=js&"
export * from "./secondaryCard.vue?vue&type=script&lang=js&"
import style0 from "./secondaryCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "secondaryCard.vue"
export default component.exports